(function() {
  function initProductSupportDirectory(section) {
    if (!section || section.dataset.productSupportReady === 'true') {
      return;
    }

    var overlay = section.querySelector('[data-support-overlay]');
    var drawer = section.querySelector('[data-support-drawer]');
    var storeModal = section.querySelector('[data-support-store-modal]');
    var videoModal = section.querySelector('[data-support-video-modal]');
    var openDrawerButtons = section.querySelectorAll('[data-support-open-drawer]');
    var closeButtons = section.querySelectorAll('[data-support-close-ui]');
    var groupButtons = section.querySelectorAll('[data-support-group-toggle]');
    var subcategoryButtons = section.querySelectorAll('[data-support-subcategory-toggle]');
    var productButtons = section.querySelectorAll('[data-support-product-button]');
    var productPanels = section.querySelectorAll('[data-support-product-panel]');
    var storeButtons = section.querySelectorAll('[data-support-open-store]');
    var videoButtons = section.querySelectorAll('[data-support-open-video]');
    var storeLinks = section.querySelectorAll('[data-support-store-link]');
    var activeLabelTargets = section.querySelectorAll('[data-support-active-label]');
    var currentStoreProduct = section.querySelector('[data-support-store-current]');
    var videoFrame = section.querySelector('[data-support-video-frame]');
    var defaultVideoTitle = videoFrame ? videoFrame.getAttribute('title') || '' : '';
    var main = section.querySelector('.product-support__main');
    var mobileBar = section.querySelector('.product-support__mobile-bar');
    var openSurface = null;
    var returnFocus = null;
    var activeProductId = null;
    var activeProductPath = '';
    var activeProductName = '';
    var activeProductHandle = '';
    var activeProductKey = '';
    var mobileBarSpacer = null;

    section.dataset.productSupportReady = 'true';

    if (mobileBar && mobileBar.parentNode) {
      mobileBarSpacer = document.createElement('div');
      mobileBarSpacer.className = 'product-support__mobile-bar-spacer';
      mobileBar.parentNode.insertBefore(mobileBarSpacer, mobileBar);
    }

    function setExpanded(container, expanded, buttonSelector, panelSelector) {
      if (!container) {
        return;
      }

      var button = container.querySelector(buttonSelector);
      var panel = container.querySelector(panelSelector);

      container.classList.toggle('is-open', expanded);

      if (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      if (panel) {
        panel.classList.toggle('is-open', expanded);
        panel.hidden = !expanded;
      }
    }

    function updateActiveLabel() {
      var label = activeProductName;
      var activePanel = section.querySelector('[data-support-product-panel].is-active');
      var groupLabel = activePanel ? activePanel.getAttribute('data-group-label') : '';
      var productName = activePanel ? activePanel.getAttribute('data-product-name') : '';

      if (groupLabel && productName) {
        label = groupLabel + ' / ' + productName;
      } else if (productName) {
        label = productName;
      }

      activeLabelTargets.forEach(function(target) {
        target.textContent = label || '';
      });
    }

    function updateStoreLinks() {
      storeLinks.forEach(function(link) {
        var baseUrl = link.getAttribute('data-store-base-url');
        var finalUrl = baseUrl;

        if (activeProductPath) {
          try {
            var url = new URL(activeProductPath, baseUrl);
            url.searchParams.set('utm_source', window.location.hostname);
            url.searchParams.set('utm_medium', 'referral');
            finalUrl = url.toString();
          } catch (error) {
            finalUrl = baseUrl;
          }
        }

        link.setAttribute('href', finalUrl);
      });

      if (currentStoreProduct) {
        currentStoreProduct.textContent = activeProductName || '';
      }
    }

    function getRequestedProductRequest() {
      try {
        var url = new URL(window.location.href);
        var requestedProduct = url.searchParams.get('product') || '';
        return {
          productHandle: url.searchParams.get('support') || requestedProduct,
          productKey: url.searchParams.get('product_key') || url.searchParams.get('product_name') || requestedProduct
        };
      } catch (error) {
        return {
          productHandle: '',
          productKey: ''
        };
      }
    }

    function syncProductQueryParam() {
      if ((!activeProductHandle && !activeProductKey) || !window.history || !window.URL) {
        return;
      }

      try {
        var url = new URL(window.location.href);
        if (activeProductKey) {
          url.searchParams.set('product', activeProductKey);
          url.searchParams.set('product_key', activeProductKey);
        } else {
          url.searchParams.set('product', activeProductHandle);
          url.searchParams.delete('product_key');
        }

        if (activeProductHandle) {
          url.searchParams.set('support', activeProductHandle);
        } else {
          url.searchParams.delete('support');
        }

        url.searchParams.delete('category');
        if (url.hash.indexOf('#category=') === 0 || url.hash.indexOf('#fp-faq-') === 0) url.hash = '';
        if (url.href !== window.location.href) window.history.pushState({}, '', url.pathname + url.search + url.hash);
      } catch (error) {}
    }

    function getHeaderOffset() {
      var rootStyles = window.getComputedStyle(document.documentElement);
      var bodyStyles = window.getComputedStyle(document.body);
      var rawValue =
        rootStyles.getPropertyValue('--support-header-current-height') ||
        bodyStyles.getPropertyValue('--support-header-current-height') ||
        '64px';
      var offset = parseFloat(rawValue);

      return Number.isNaN(offset) ? 64 : offset;
    }

    function resetMobileBarPin() {
      if (!mobileBar) {
        return;
      }

      mobileBar.classList.remove('is-pinned');
      mobileBar.style.removeProperty('--product-support-mobile-bar-left');
      mobileBar.style.removeProperty('--product-support-mobile-bar-width');

      if (mobileBarSpacer) {
        mobileBarSpacer.classList.remove('is-active');
        mobileBarSpacer.style.height = '';
      }
    }

    function syncMobileBarPin() {
      if (!mobileBar || !mobileBarSpacer || !main) {
        return;
      }

      if (window.innerWidth >= 1024) {
        resetMobileBarPin();
        return;
      }

      var headerOffset = getHeaderOffset();
      var referenceElement = mobileBar.classList.contains('is-pinned') ? mobileBarSpacer : mobileBar;
      var spacerTop = referenceElement.getBoundingClientRect().top + window.scrollY;
      var mainTop = main.getBoundingClientRect().top + window.scrollY;
      var mainBottom = mainTop + main.offsetHeight;
      var barHeight = mobileBar.offsetHeight;
      var barStyles = window.getComputedStyle(mobileBar);
      var barMarginTop = parseFloat(barStyles.marginTop) || 0;
      var barMarginBottom = parseFloat(barStyles.marginBottom) || 0;
      var barOuterHeight = barHeight + barMarginTop + barMarginBottom;
      var scrollTop = window.scrollY;
      var shouldPin = scrollTop + headerOffset >= spacerTop && scrollTop + headerOffset + barOuterHeight < mainBottom;

      if (!shouldPin) {
        resetMobileBarPin();
        return;
      }

      var mainRect = main.getBoundingClientRect();

      mobileBar.classList.add('is-pinned');
      mobileBar.style.setProperty('--product-support-mobile-bar-left', Math.round(mainRect.left) + 'px');
      mobileBar.style.setProperty('--product-support-mobile-bar-width', Math.round(mainRect.width) + 'px');

      mobileBarSpacer.classList.add('is-active');
      mobileBarSpacer.style.height = barOuterHeight + 'px';
    }

    function closeUi() {
      var wasOpen = openSurface;
      openSurface = null;
      [drawer, storeModal, videoModal].forEach(function(surface) { if (surface) surface.inert = true; });
      document.body.classList.remove('product-support-ui-lock');

      if (overlay) {
        overlay.classList.remove('is-active');
        overlay.hidden = true;
      }

      if (drawer) {
        drawer.classList.remove('is-active');
        drawer.setAttribute('aria-hidden', 'true');
      }

      if (storeModal) {
        storeModal.classList.remove('is-active');
        storeModal.setAttribute('aria-hidden', 'true');
      }

      if (videoModal) {
        videoModal.classList.remove('is-active');
        videoModal.setAttribute('aria-hidden', 'true');
      }

      if (videoFrame) {
        videoFrame.setAttribute('src', '');
      }

      openDrawerButtons.forEach(function(button) {
        button.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      });
      if (wasOpen && returnFocus) returnFocus.focus({ preventScroll: true });
    }

    function openUiSurface(surfaceName, trigger) {
      trigger = trigger || document.activeElement;
      closeUi();
      returnFocus = trigger;
      openSurface = surfaceName;
      var surface = surfaceName === 'drawer' ? drawer : surfaceName === 'store' ? storeModal : videoModal;
      if (surface) {
        surface.inert = false;
        requestAnimationFrame(function() { var first = surface.querySelector('button, a[href]'); if (first) first.focus(); });
      }
      document.body.classList.add('product-support-ui-lock');

      if (overlay) {
        overlay.hidden = false;
        overlay.classList.add('is-active');
      }

      if (surfaceName === 'drawer' && drawer) {
        drawer.classList.add('is-active');
        drawer.setAttribute('aria-hidden', 'false');
        return;
      }

      if (surfaceName === 'store' && storeModal) {
        storeModal.classList.add('is-active');
        storeModal.setAttribute('aria-hidden', 'false');
        return;
      }

      if (surfaceName === 'video' && videoModal) {
        videoModal.classList.add('is-active');
        videoModal.setAttribute('aria-hidden', 'false');
      }
    }

    function toEmbedUrl(videoUrl) {
      if (!videoUrl) {
        return '';
      }

      try {
        var url = new URL(videoUrl, window.location.origin);
        var hostname = url.hostname.replace(/^www\./, '');
        var pathname = url.pathname;
        var embedUrl = videoUrl;

        if (hostname === 'youtu.be') {
          var shortId = pathname.replace(/^\/+/, '').split('/')[0];

          if (shortId) {
            embedUrl = 'https://www.youtube.com/embed/' + shortId + '?autoplay=1&rel=0';
          }
        } else if (hostname.indexOf('youtube.com') !== -1) {
          if (pathname.indexOf('/embed/') === 0) {
            embedUrl = url.toString();
            if (embedUrl.indexOf('autoplay=1') === -1) {
              embedUrl += (embedUrl.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
            }
          } else if (pathname.indexOf('/shorts/') === 0) {
            var shortsId = pathname.split('/shorts/')[1].split('/')[0];

            if (shortsId) {
              embedUrl = 'https://www.youtube.com/embed/' + shortsId + '?autoplay=1&rel=0';
            }
          } else {
            var videoId = url.searchParams.get('v');

            if (videoId) {
              embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
            }
          }
        } else if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com') {
          var vimeoId = '';

          if (pathname.indexOf('/video/') === 0) {
            vimeoId = pathname.split('/video/')[1].split('/')[0];
          } else {
            vimeoId = pathname.replace(/^\/+/, '').split('/')[0];
          }

          if (vimeoId) {
            embedUrl = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1';
          }
        }

        return embedUrl;
      } catch (error) {
        return videoUrl;
      }
    }

    function revealActiveAncestors() {
      productButtons.forEach(function(button) {
        var matches = button.getAttribute('data-product-id') === activeProductId;
        var subcategoryContainer = button.closest('[data-support-subcategory-item]');
        var groupContainer = button.closest('[data-support-group-item]');

        button.classList.toggle('is-active', matches);
        button.setAttribute('aria-pressed', matches ? 'true' : 'false');

        if (matches) {
          setExpanded(subcategoryContainer, true, '[data-support-subcategory-toggle]', '[data-support-subcategory-panel]');
          setExpanded(groupContainer, true, '[data-support-group-toggle]', '[data-support-group-panel]');
        }
      });
    }

    function setActiveProduct(productId, options) {
      var nextPanel = section.querySelector('[data-support-product-panel][id="' + productId + '"]');

      if (!nextPanel) {
        return;
      }

      options = options || {};

      if (options.syncUrl !== false) { var notice = section.querySelector('[data-support-not-found]'); if (notice) notice.hidden = true; }
      activeProductId = productId;
      activeProductPath = nextPanel.getAttribute('data-product-path') || '';
      activeProductName = nextPanel.getAttribute('data-product-name') || '';
      activeProductHandle = nextPanel.getAttribute('data-support-handle') || '';
      activeProductKey = nextPanel.getAttribute('data-product-key') || '';

      productPanels.forEach(function(panel) {
        var isActive = panel.id === productId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      revealActiveAncestors();
      updateActiveLabel();
      updateStoreLinks();

      if (options.syncUrl !== false) {
        syncProductQueryParam();
      }
    }

    function initFaqs(panel) {
      var items = Array.prototype.slice.call(panel.querySelectorAll('[data-support-faq-item]'));

      if (!items.length) {
        return;
      }

      function openItem(itemToOpen) {
        items.forEach(function(item) {
          var isOpen = item === itemToOpen;
          var trigger = item.querySelector('[data-support-faq-trigger]');
          var answer = item.querySelector('[data-support-faq-answer]');

          item.classList.toggle('is-open', isOpen);

          if (trigger) {
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          }

          if (answer) {
            answer.hidden = !isOpen;
          }
        });
      }

      items.forEach(function(item) {
        var trigger = item.querySelector('[data-support-faq-trigger]');

        if (!trigger) {
          return;
        }

        trigger.addEventListener('click', function() {
          var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          openItem(isExpanded ? null : item);
        });
      });
    }

    groupButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var container = button.closest('[data-support-group-item]');
        var expanded = button.getAttribute('aria-expanded') === 'true';
        setExpanded(container, !expanded, '[data-support-group-toggle]', '[data-support-group-panel]');
      });
    });

    subcategoryButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var container = button.closest('[data-support-subcategory-item]');
        var expanded = button.getAttribute('aria-expanded') === 'true';
        setExpanded(container, !expanded, '[data-support-subcategory-toggle]', '[data-support-subcategory-panel]');
      });
    });

    productButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var productId = button.getAttribute('data-product-id');

        if (!productId) {
          return;
        }

        setActiveProduct(productId);

        if (window.innerWidth <= 1023 && openSurface === 'drawer') {
          closeUi();
        }
      });
    });

    storeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var productPath = button.getAttribute('data-product-path');
        var productName = button.getAttribute('data-product-name');

        if (!productPath) {
          return;
        }

        activeProductPath = productPath;

        if (productName) {
          activeProductName = productName;
        }

        updateActiveLabel();
        updateStoreLinks();
        openUiSurface('store');
      });
    });

    videoButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var rawUrl = button.getAttribute('data-video-url');
        var title = button.getAttribute('data-video-title') || '';
        var embedUrl = toEmbedUrl(rawUrl);

        if (!embedUrl || !videoFrame) {
          return;
        }

        openUiSurface('video');

        videoFrame.setAttribute('src', embedUrl);
        videoFrame.setAttribute('title', title || defaultVideoTitle);
      });
    });

    openDrawerButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        openUiSurface('drawer', button);
        button.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      });
    });

    closeButtons.forEach(function(button) {
      button.addEventListener('click', closeUi);
    });

    if (overlay) {
      overlay.addEventListener('click', closeUi);
    }

    var swallowEscapeKeyup = false;
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && openSurface) {
        event.preventDefault();
        event.stopImmediatePropagation();
        swallowEscapeKeyup = true;
        closeUi();
      }
    }, true);
    document.addEventListener('keyup', function(event) {
      if (event.key === 'Escape' && swallowEscapeKeyup) {
        event.stopImmediatePropagation();
        swallowEscapeKeyup = false;
      }
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Tab' && openSurface) {
        var surface = openSurface === 'drawer' ? drawer : openSurface === 'store' ? storeModal : videoModal;
        var focusable = Array.prototype.slice.call(surface.querySelectorAll('button:not([disabled]), a[href], iframe, input')).filter(function(el) { return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      if (event.key === 'Escape' && openSurface) {
        closeUi();
      }
    });

    window.addEventListener(
      'resize',
      function() {
        if (window.innerWidth >= 1024 && openSurface === 'drawer') {
          closeUi();
        }

        syncMobileBarPin();
      },
      { passive: true }
    );

    window.addEventListener('scroll', syncMobileBarPin, { passive: true });

    productPanels.forEach(initFaqs);

    function restoreRequestedProduct() {
      if (!productPanels.length) return;
      var request = getRequestedProductRequest();
      var url = new URL(window.location.href);
      var category = url.searchParams.get('category') || new URLSearchParams(url.hash.slice(1)).get('category') || '';
      var panels = Array.prototype.slice.call(productPanels);
      var requested = panels.find(function(panel) {
        return (request.productHandle && panel.dataset.supportHandle === request.productHandle) ||
          (request.productKey && panel.dataset.productKey === request.productKey);
      });
      var missing = Boolean((request.productHandle || request.productKey) && !requested);
      var subcategory = new URLSearchParams(url.hash.slice(1)).get('subcategory') || '';
      if (!requested && subcategory) requested = panels.find(function(panel) { return (panel.dataset.subcategoryLabel || '').toLowerCase() === subcategory.toLowerCase() && (!category || (panel.dataset.groupQueryLabel || panel.dataset.groupLabel || '').toLowerCase() === category.toLowerCase()); });
      if (!requested && category) requested = panels.find(function(panel) { return (panel.dataset.groupQueryLabel || panel.dataset.groupLabel || '').toLowerCase() === category.toLowerCase(); });
      var notice = section.querySelector('[data-support-not-found]');
      if (notice) notice.hidden = !missing;
      setActiveProduct((requested || productPanels[0]).id, { syncUrl: false });
      var faqId = url.hash.slice(1);
      var selectedPanel = requested || productPanels[0];
      if (new URLSearchParams(url.hash.slice(1)).get('tab') === 'videos') {
        var videoSection = selectedPanel.querySelector('[data-support-video-section]');
        if (videoSection) requestAnimationFrame(function() {
          videoSection.focus({ preventScroll: true });
          videoSection.scrollIntoView({ block: 'center' });
        });
      }

      var faq = Array.prototype.find.call(selectedPanel.querySelectorAll('[data-support-faq-item]'), function(item) { return item.id === faqId; });
      if (faq) {
        var trigger = faq.querySelector('[data-support-faq-trigger]');
        if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
        requestAnimationFrame(function() {
          trigger.focus({ preventScroll: true });
          faq.scrollIntoView({ block: 'center' });
        });
      }

    }
    window.addEventListener('popstate', restoreRequestedProduct);
    window.addEventListener('hashchange', restoreRequestedProduct);
    closeUi();
    restoreRequestedProduct();

    syncMobileBarPin();
  }

  function initAllProductSupportDirectories(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-product-support-directory]')) {
      initProductSupportDirectory(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('[data-product-support-directory]')).forEach(function(section) {
      initProductSupportDirectory(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllProductSupportDirectories(document);
    });
  } else {
    initAllProductSupportDirectories(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllProductSupportDirectories(event.target);
  });
})();
